import React, { useEffect } from "react";

function ClosePrint() {
  useEffect(() => {
    window.close();
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
      }}>
      PRINT LOADING
    </div>
  );
}

export default ClosePrint;
